import {
  BodyText,
  Button,
  Heading,
  Icon,
  IconSet,
  Image,
  Layout,
  ModalBody,
} from '@postscript/components';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { useInfinityTestingBillingStatus } from 'components/billing/modules/plans/hooks/useInfinityTestingBillingStatus';
import { useGlobalModal } from 'components/GlobalModal/globalModal';
import { useUser } from 'controllers/contexts/user';

import InfinityTestingPreview from 'img/infinity-testing-modal.gif';

import { FlowModes, FlowTypes } from 'components/flowBuilder/constants';
import { FlowWizardOptions } from 'components/flowBuilder/constants/trackingEvents';
import { createDraftFlowWithInfinityMessageAction } from 'components/flowBuilder/utils/flows';
import {
  COMMON_EVENT_NAMES,
  logEvent,
  MODAL_TYPES,
  PRODUCT_AREAS,
} from 'utils/events';

const StyledInfoCardContainer = styled.div`
  background-color: var(--modal-bkg-color);
  bottom: 0;
  height: 347px;
  padding-top: var(--spacing-5);
  padding-right: var(--spacing-6);
  padding-left: var(--spacing-6);
  padding-bottom: var(--spacing-7);
  position: absolute;
  width: 100%;
`;

const WelcomeToInfinityTestingModal = () => {
  const { user } = useUser();
  const { push } = useHistory();
  const { hideModal } = useGlobalModal();
  const { trialExpired } = useInfinityTestingBillingStatus();

  const tryInfinityTestingNow = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    logEvent(COMMON_EVENT_NAMES.MODAL_CTA_CLICKED, {
      modal_type: MODAL_TYPES.INFINITY_TESTING,
      product_area: PRODUCT_AREAS.BILLING,
      shop_id: user.shop_id,
      text: (event.target as HTMLButtonElement).innerText,
    });

    const draftFlow = createDraftFlowWithInfinityMessageAction({
      mode: FlowModes.ADVANCED,
      type: FlowTypes.CAMPAIGN,
    });
    hideModal();
    push('/campaigns/flows/new', {
      flow: draftFlow,
      from: FlowWizardOptions.INFINITY_TEST_CAMPAIGN,
    });
  };

  return (
    <ModalBody>
      <Layout align="right">
        <Icon
          component={IconSet.Close}
          size="large"
          onClick={tryInfinityTestingNow}
          style={{
            cursor: 'pointer',
            position: 'absolute',
            top: 10,
            right: 10,
            zIndex: 10,
            color: 'var(--gray-9)',
          }}
        />
      </Layout>
      <Image
        height={280}
        alt="Brand Center Toggles"
        frame="square"
        src={InfinityTestingPreview}
      />
      <StyledInfoCardContainer>
        <Heading size="x-small">
          {trialExpired
            ? '🎉 Welcome to Infinity Testing!'
            : '🎉 Welcome to Your 30-Day Infinity Testing Trial!'}
        </Heading>
        <BodyText style={{ marginTop: 'var(--spacing-4)' }} size="small">
          Your Brand Center is already set up—now it’s time to put it to work!
        </BodyText>
        <BodyText style={{ marginTop: 'var(--spacing-4)' }} size="small">
          With <strong>Infinity Testing</strong>, you can:
        </BodyText>
        <BodyText size="small" style={{ marginLeft: 'var(--spacing-4)' }}>
          <li>
            Test variations to ensure you’re sending the top-performing message.
          </li>
          <li>Automatically optimize your messages to increase revenue.</li>
          <li>Gain insights to refine your customer engagement strategy.</li>
        </BodyText>
        <Layout align="center">
          <Button
            style={{ marginTop: 'var(--spacing-5)' }}
            onClick={tryInfinityTestingNow}
          >
            Try Infinity Testing Now
          </Button>
        </Layout>
      </StyledInfoCardContainer>
    </ModalBody>
  );
};

export default WelcomeToInfinityTestingModal;
